import {createPopper} from '@popperjs/core';

export default function initTooltips() {
    $('[aria-describedby="tooltip"]').not('[tooltip-initialized]').each(function () {
        let $element = $(this)[0];
        let $tooltip = $(this).find('[role="tooltip"]')[0];

        const popperInstance = createPopper($element, $tooltip, {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 8,
                    },
                },
            ],
        });

        function show() {
            $tooltip.setAttribute('data-show', '');

            popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    {name: 'eventListeners', enabled: true},
                ],
            }));

            popperInstance.update();
        }

        function hide() {
            $tooltip.removeAttribute('data-show');

            popperInstance.setOptions((options) => ({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    {name: 'eventListeners', enabled: false},
                ],
            }));
        }

        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        showEvents.forEach((event) => {
            $element.addEventListener(event, show);
        });

        hideEvents.forEach((event) => {
            $element.addEventListener(event, hide);
        });

        $element.setAttribute('tooltip-initialized', '');
    });
}